<template>
  <div>
    <!-- 语言切换器 -->
    <div class="language-switcher-container">
      <LanguageSwitcher />
    </div>
    
    <!-- 英雄区域 -->
    <section id="home" class="hero-section">
      <div class="video-background">
        <video 
          autoplay 
          muted 
          loop 
          playsinline
          class="background-video"
        >
          <source src="../assets/c565b513b8c3b19cf5d32daa3bdbbe63_raw.mp4" type="video/mp4">
          <!-- 如果浏览器不支持视频，显示备用背景 -->
        </video>
      </div>
      <div class="video-overlay"></div>
      <div class="hero-content">
        <div class="hero-text">
          <h1 class="hero-title">{{ $t('hero.title') }}</h1>
          <p class="hero-subtitle">{{ $t('hero.subtitle') }}</p>
          <div class="hero-buttons">
            <button class="btn btn-primary" @click="scrollToSection('store')">{{ $t('hero.viewNow') }}</button>
            <button class="btn btn-outline" @click="scrollToSection('about')">{{ $t('hero.learnMore') }}</button>
          </div>
        </div>
        <div class="hero-image-container">
          <div class="glass-card">
            <img src="../assets/背景图虚层.png" :alt="$t('hero.title')" class="hero-product-image" />
          </div>
        </div>
      </div>
    </section>

    <!-- 线上商店区域 -->
    <section id="store" class="store-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('store.title') }}</h2>
          <p class="section-subtitle">{{ $t('store.subtitle') }}</p>
        </div>
        <div class="product-grid">
          <div 
            v-for="product in products" 
            :key="product.id" 
            class="product-card"
            @click="viewProductDetail(product)"
          >
            <div class="product-image">
              <img :src="product.shopAvatar" :alt="product.displayName" style="width: 600px; height: 300px; object-fit: cover;" />
              <div class="product-overlay">
                <button class="btn btn-primary">{{ $t('store.viewNow') }}</button>
              </div>
            </div>
            <div class="product-info">
              <h3 class="product-name">{{ product.displayName }}</h3>
              <p class="product-description">{{ product.displayContent }}</p>
              <div class="product-price">
                <!-- <span class="current-price">{{ $t('store.currency') }}{{ product.displayPrice }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品特点区域 -->
    <section id="features" class="features-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('features.title') }}</h2>
          <p class="section-subtitle">{{ $t('features.subtitle') }}</p>
        </div>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-image">
              <img src="../assets/特点1.png" :alt="$t('features.feature1.title')" />
            </div>
            <div class="feature-content">
              <h3>{{ $t('features.feature1.title') }}</h3>
              <p>{{ $t('features.feature1.description') }}</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="feature-image">
              <img src="../assets/特点2.png" :alt="$t('features.feature2.title')" />
            </div>
            <div class="feature-content">
              <h3>{{ $t('features.feature2.title') }}</h3>
              <p>{{ $t('features.feature2.description') }}</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="feature-image">
              <img src="../assets/特点3.png" :alt="$t('features.feature3.title')" />
            </div>
            <div class="feature-content">
              <h3>{{ $t('features.feature3.title') }}</h3>
              <p>{{ $t('features.feature3.description') }}</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="feature-image">
              <img src="../assets/特点4.png" :alt="$t('features.feature4.title')" />
            </div>
            <div class="feature-content">
              <h3>{{ $t('features.feature4.title') }}</h3>
              <p>{{ $t('features.feature4.description') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们区域 -->
    <section id="about" class="about-section">
      <div class="container">
        <div class="about-header">
          <h2 class="about-title">{{ $t('about.title') }}</h2>
          <p class="about-subtitle">{{ $t('about.subtitle') }}</p>
        </div>
        <div class="about-description">
          <p>{{ $t('about.content') }}</p>
        </div>
      </div>
    </section>

    <!-- 企业新闻区域 -->
    <section id="news" class="news-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('news.title') }}</h2>
          <p class="section-subtitle">{{ $t('news.subtitle') }}</p>
        </div>
        
        <!-- 如果新闻列表有数据，则显示新闻列表 -->
        <div v-if="newsItems.length > 0" class="news-grid">
          <div 
            v-for="news in newsItems" 
            :key="news.id" 
            class="news-card"
          >
            <div class="news-image">
              <img :src="news.avatar" :alt="news.displayName" />
              <div class="news-overlay">
                <!-- <button class="btn btn-primary">{{ $t('news.readMore') }}</button> -->
              </div>
            </div>
            <div class="news-info">
              <h3 class="news-name">{{ news.displayName }}</h3>
              <p class="news-content">{{ news.displayContent }}</p>
            </div>
          </div>
        </div>
        
        <!-- 如果新闻列表没有数据，则显示没有发布任何博客文章 -->
        <div v-else class="news-empty">
          <p class="empty-text">{{ $t('news.empty') }}</p>
        </div>
      </div>
    </section>

    <!-- 应用场景区域 -->
    <section id="applications" class="applications-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('applications.title') }}</h2>
          <p class="section-subtitle">{{ $t('applications.subtitle') }}</p>
        </div>
        
        <div class="applications-content">
          <div class="application-item">
            <h3 class="application-title">{{ $t('applications.travel.title') }}</h3>
            <p class="application-description">{{ $t('applications.travel.description') }}</p>
          </div>
          
          <div class="application-item">
            <h3 class="application-title">{{ $t('applications.hotel.title') }}</h3>
            <p class="application-description">{{ $t('applications.hotel.description') }}</p>
          </div>
          
          <div class="application-item">
            <h3 class="application-title">{{ $t('applications.home.title') }}</h3>
            <p class="application-description">{{ $t('applications.home.description') }}</p>
          </div>
          
          <div class="application-item">
            <h3 class="application-title">{{ $t('applications.medical.title') }}</h3>
            <p class="application-description">{{ $t('applications.medical.description') }}</p>
          </div>
        </div>
        
        <div class="applications-summary">
          <p class="summary-title">{{ $t('applications.summaryTitle') }}</p>
          <p class="summary-description">{{ $t('applications.summaryDescription') }}</p>
        </div>
      </div>
    </section>

    <!-- 联系我们区域 -->
    <section id="contact" class="contact-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('contact.title') }}</h2>
          <p class="section-subtitle">{{ $t('contact.subtitle') }}</p>
        </div>
        <div class="contact-content">
          <div class="contact-info">
            <div class="contact-item">
              <div class="contact-icon">📍</div>
              <div class="contact-details">
                <h4>{{ $t('contact.address') }}</h4>
                <p>{{ $t('contact.addressText') }}</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">📞</div>
              <div class="contact-details">
                <h4>{{ $t('contact.phone') }}</h4>
                <p>{{ $t('contact.phoneText') }}</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">✉️</div>
              <div class="contact-details">
                <h4>{{ $t('contact.email') }}</h4>
                <p>{{ $t('contact.emailText') }}</p>
              </div>
            </div>
          </div>
          <div class="contact-form">
            <form @submit.prevent="submitForm">
              <div class="form-group">
                <input type="text" v-model="form.name" :placeholder="$t('contact.form.name')" required />
              </div>
              <div class="form-group">
                <input type="email" v-model="form.email" :placeholder="$t('contact.form.email')" required />
              </div>
              <div class="form-group">
                <input type="tel" v-model="form.phone" :placeholder="$t('contact.form.phone')" />
              </div>
              <div class="form-group">
                <textarea v-model="form.message" :placeholder="$t('contact.form.message')" rows="5" required></textarea>
              </div>
              <button type="submit" class="btn btn-primary btn-full" :disabled="isSubmitting">
                {{ isSubmitting ? $t('contact.form.submitting') : $t('contact.form.submit') }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getProductList, contactUs } from '../api/product'
import { getNewsList } from '../api/news'
import LanguageSwitcher from '../components/LanguageSwitcher.vue'
import { processProductList, processNewsList } from '../utils/i18nData'

export default {
  name: 'HomePage',
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      // 原始产品数据
      rawProducts: [],
      // 原始新闻数据
      rawNewsItems: [],
      // 联系表单数据
      form: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      // 表单提交状态
      isSubmitting: false,
      // 分页数据
      productPage: 1,
      productPageSize: 8,
      newsPage: 1,
      newsPageSize: 3
    }
  },
  computed: {
    // 当前语言
    currentLocale() {
      return this.$i18n.locale
    },
    // 处理后的产品数据（根据当前语言）
    products() {
      return processProductList(this.rawProducts, this.currentLocale)
    },
    // 处理后的新闻数据（根据当前语言）
    newsItems() {
      return processNewsList(this.rawNewsItems, this.currentLocale)
    }
  },
  watch: {
    // 监听语言切换，虽然computed会自动更新，但这里可以添加额外逻辑
    currentLocale(newLocale, oldLocale) {
      console.log(`语言从 ${oldLocale} 切换到 ${newLocale}`)
    }
  },
  mounted() { 
    this.loadProducts();
    this.loadNews();
    this.initVideoBackground();
  },
  methods: {
    // 加载产品数据
    async loadProducts() {
      try {
        const response = await getProductList();
        // console.log('产品数据:', response.data);
        this.rawProducts = response.data.data.items || [];
        // 根据实际返回的数据结构调整
      } catch (error) {
        console.error('加载产品数据失败:', error);
      }
    },
    
    // 加载新闻数据
    async loadNews() {
      try {
        const response = await getNewsList();
        // console.log('新闻数据:', response.data);
        // 根据实际返回的数据结构调整
        this.rawNewsItems = response.data.data.items || [];  
      } catch (error) {
        console.error('加载新闻数据失败:', error);
      }
    },
    
    // 获取产品名称
    getProductName(productId) {
      const nameMap = {
        1: '一次性床品四件套',
        2: '有机茶叶',
        3: '草本精华', 
        4: '植物精油'
      };
      return nameMap[productId] || '一次性床品四件套';
    },
    // 获取产品描述
    getProductDescription(productId) {
      const descMap = {
        1: '纯天然野生蜂蜜，营养丰富',
        2: '高山有机茶叶，清香回甘',
        3: '天然草本提取，温和养护',
        4: '纯植物精油，舒缓放松'
      };
      return descMap[productId] || '纯天然野生蜂蜜，营养丰富';
    },
    // 滚动到指定区域
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const navHeight = 80; // 导航栏高度
        const elementPosition = element.offsetTop - navHeight;
        
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    },
    // 查看商品详情
    viewProductDetail(product) {
      this.$router.push(`/product/${product.id}`);
    },
    // 获取新闻图片
    getNewsImage(newsId) {
      // 使用随机图片服务，根据newsId生成不同的图片
      const imageId = (newsId * 100) + 500; // 生成不同的图片ID
      return `https://picsum.photos/400/250?random=${imageId}`;
    },
    // 邮箱格式校验
    validateEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    },
    // 电话号码格式校验
    validatePhone(phone) {
      // 支持中国大陆手机号、固话、国际号码等多种格式
      const phoneRegex = /^(\+?86[-\s]?)?((1[3-9]\d{9})|(\d{3,4}[-\s]?\d{7,8})|(\+?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{1,9}))$/;
      return phoneRegex.test(phone.replace(/\s/g, ''));
    },
    // 提交表单
    async submitForm() {
      // 防止重复提交
      if (this.isSubmitting) {
        return;
      }

      // 表单验证
      if (!this.form.name.trim() || !this.form.email.trim() || !this.form.message.trim()) {
        alert(this.$t('contact.form.validation'));
        return;
      }

      // 邮箱格式校验
      if (!this.validateEmail(this.form.email)) {
        alert(this.$t('contact.form.emailInvalid'));
        return;
      }

      // 电话号码格式校验（如果填写了电话）
      if (this.form.phone.trim() && !this.validatePhone(this.form.phone)) {
        alert(this.$t('contact.form.phoneInvalid'));
        return;
      }

      this.isSubmitting = true;

      try {
        // 调用联系我们API
        const response = await contactUs(this.form);
        
        // 显示成功消息（从API返回的消息或默认消息）
        const successMessage = response.data.msg || this.$t('contact.submitSuccess');
        alert(successMessage);
        
        // 清空表单
        this.form = {
          name: '',
          email: '',
          phone: '',
          message: ''
        };
      } catch (error) {
        console.error('表单提交失败:', error);
        
        // 显示错误消息
        let errorMessage = this.$t('contact.submitError');
        
        // 如果API返回了错误消息，使用API的消息
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        
        alert(errorMessage);
      } finally {
        this.isSubmitting = false;
      }
    },
    // 初始化视频背景
    initVideoBackground() {
      this.$nextTick(() => {
        const video = document.querySelector('.background-video');
        if (video) {
          // 确保视频静音（某些浏览器要求静音才能自动播放）
          video.muted = true;
          
          // 尝试播放视频
          const playPromise = video.play();
          
          if (playPromise !== undefined) {
            playPromise.then(() => {
              console.log('视频背景播放成功');
            }).catch(error => {
              console.log('视频背景自动播放失败:', error);
              // 如果自动播放失败，可以添加用户交互后播放的逻辑
            });
          }
          
          // 监听视频加载错误
          video.addEventListener('error', (e) => {
            console.error('视频加载失败:', e);
            // 可以在这里设置备用背景
            const videoBackground = document.querySelector('.video-background');
            if (videoBackground) {
              videoBackground.style.background = 'linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(139, 195, 74, 0.15) 100%)';
            }
          });
        }
      });
    }
  }
}
</script>

<style scoped>
/* 语言切换器容器 */
.language-switcher-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
}

/* 英雄区域 */
.hero-section {
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  overflow: hidden;
}

/* 视频背景 */
.video-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -2;
  overflow: hidden;
}

.background-video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%);
  object-fit: cover;
  z-index: -1;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.2) 50%,
    rgba(0, 0, 0, 0.4) 100%);
  z-index: -1;
}



.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
  position: relative;
  z-index: 1;
}

.hero-text {
  animation: slideInLeft 1s ease-out;
}

.hero-title {
  font-size: 3rem;
  font-weight: 700;
  color: #2E7D32;
  margin-bottom: 20px;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.hero-subtitle {
  font-size: 1.3rem;
  color: white;
  margin-bottom: 40px;
  font-weight: 500;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

/* 右侧玻璃液态效果 */
.hero-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  animation: slideInRight 1s ease-out;
}

/* .glass-card {
  position: relative;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.3),
    inset 0 -1px 0 rgba(255, 254, 254, 0.1);
  overflow: hidden;
  transform: perspective(1000px) rotateY(-5deg) rotateX(2deg);
  transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
} */

/* .glass-card:hover {
  transform: perspective(1000px) rotateY(0deg) rotateX(0deg) scale(1.02);
  box-shadow: 
    0 16px 64px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.4),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
} */

/* .glass-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -50%;
  width: 50%;
  height: 100%;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(255, 255, 255, 0.2) 50%, 
    transparent 100%);
  transform: skewX(-25deg);
  animation: shimmer 3s ease-in-out infinite;
} */

@keyframes shimmer {
  0% { left: -50%; }
  50% { left: 150%; }
  100% { left: -50%; }
}

.hero-product-image {
  width: 100%;
  max-width: 450px;
  height: auto;
  object-fit: cover;
  border-radius: 20px;
  transition: transform 0.6s ease;
}

.glass-card:hover .hero-product-image {
  transform: scale(1.05);
}

/* 区域通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 按钮样式 */
.btn {
  display: inline-block;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.btn-primary {
  background: linear-gradient(135deg, #4CAF50, #2E7D32);
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #45a049, #1B5E20);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.btn-outline {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-outline:hover {
  background: white;
  color: #4CAF50;
}

.btn-full {
  width: 100%;
}

.section-header {
  text-align: center;
  margin-bottom: 20px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2E7D32;
  margin-bottom: 16px;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* 线上商店区域 */
.store-section {
   /* padding: 100px 0; */
  background: white;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
}

.product-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
}

.product-image {
  position: relative;
  overflow: hidden;
  /* aspect-ratio: 1; */
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.product-image:hover img {
  transform: scale(1.05);
}

.product-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.product-card:hover .product-overlay {
  opacity: 1;
}

.product-info {
  padding: 24px;
}

.product-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.product-description {
  color: #666;
  margin-bottom: 16px;
  line-height: 1.5;
}

.product-price {
  display: flex;
  align-items: center;
  gap: 10px;
}

.current-price {
  font-size: 1.3rem;
  font-weight: 700;
  color: #4CAF50;
}

/* 关于我们区域 */
.about-section {
  /* padding: 80px 0; */
  background: white;
}

.about-header {
  text-align: center;
  margin-bottom: 60px;
}

.about-title {
  font-size: 3rem;
  font-weight: 700;
  color: #4CAF50;
  margin-bottom: 16px;
  line-height: 1.2;
}

.about-subtitle {
  font-size: 1.5rem;
  color: #666;
  font-weight: 400;
  margin: 0;
}

.about-description {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}

.about-description p {
  font-size: 1.1rem;
  color: #333;
  line-height: 2;
  margin: 0;
  font-weight: 400;
  letter-spacing: 0.5px;
}

/* 产品特点区域 */
.features-section {
  padding: 100px 0;
  background: linear-gradient(135deg, 
    rgba(245, 255, 245, 0.3) 0%, 
    rgba(232, 245, 233, 0.5) 50%,
    rgba(245, 255, 245, 0.3) 100%);
  position: relative;
}

.features-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800"><defs><pattern id="features-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="25" r="15" fill="%234CAF50" opacity="0.05"/><circle cx="25" cy="75" r="10" fill="%238BC34A" opacity="0.03"/></pattern></defs><rect width="100%" height="100%" fill="url(%23features-pattern)"/></svg>');
  background-size: 200px 200px;
  opacity: 0.6;
  z-index: 0;
}

.features-section .container {
  position: relative;
  z-index: 1;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 10px;
  margin-top: 60px;
}

.feature-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 
    0 10px 40px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.5);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(76, 175, 80, 0.1);
  position: relative;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4CAF50, #8BC34A, #4CAF50);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.feature-card:hover::before {
  opacity: 1;
}

.feature-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(76, 175, 80, 0.2);
}

.feature-image {
  height: 220px;
  overflow: hidden;
  position: relative;
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.05), rgba(139, 195, 74, 0.05));
}

.feature-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 0.4s ease;
  padding: 20px;
}

.feature-card:hover .feature-image img {
  transform: scale(1.1) rotate(2deg);
}

.feature-content {
  padding: 30px 24px;
  text-align: center;
}

.feature-content h3 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2E7D32;
  margin-bottom: 16px;
  position: relative;
  display: inline-block;
}

.feature-content h3::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #4CAF50, #8BC34A);
  border-radius: 2px;
  opacity: 0;
  transition: all 0.3s ease;
}

.feature-card:hover .feature-content h3::after {
  opacity: 1;
  width: 60px;
}

.feature-content p {
  color: #555;
  line-height: 1.8;
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
}

/* 企业新闻区域 */
.news-section {
  padding: 80px 0;
  background: white;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
}

.news-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
}

.news-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
}

.news-image {
  position: relative;
  overflow: hidden;
  height: 200px;
}

.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.news-image:hover img {
  transform: scale(1.05);
}

.news-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.news-card:hover .news-overlay {
  opacity: 1;
}

.news-info {
  padding: 24px;
}

.news-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.4;
}

.news-content {
  color: #666;
  line-height: 1.6;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  overflow: hidden;
}

.news-empty {
  text-align: center;
  padding: 60px 0;
}

.empty-text {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
  font-weight: 400;
}

/* 应用场景区域 */
.applications-section {
  padding: 80px 0;
  background: white;
}

.applications-header {
  text-align: center;
  margin-bottom: 60px;
}

.applications-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #4CAF50;
  margin-bottom: 16px;
  line-height: 1.2;
}

.applications-subtitle {
  font-size: 1.1rem;
  color: #666;
  font-weight: 400;
  margin: 0;
}

.applications-content {
  /* max-width: 800px; */
  margin: 0 auto 60px;
}

.application-item {
  margin-bottom: 40px;
}

.application-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #4CAF50;
  margin-bottom: 12px;
  text-align: left;
}

.application-description {
  color: #333;
  line-height: 1.8;
  font-size: 1rem;
  margin: 0;
  text-align: left;
}

.applications-summary {
  /* max-width: 800px; */
  margin: 0 auto;
  text-align: left;
}

.summary-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.6;
}

.summary-description {
  color: #333;
  line-height: 1.8;
  font-size: 1rem;
  margin: 0;
}

/* 联系我们区域 */
.contact-section {
  padding: 100px 0;
  background: #F8FDF8;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: flex-start;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.contact-item {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.contact-icon {
  font-size: 1.5rem;
  background: #E8F5E8;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.contact-details h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2E7D32;
  margin-bottom: 4px;
}

.contact-details p {
  color: #666;
}

.contact-form {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 20px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #E5E5E5;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #4CAF50;
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

/* 动画 */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .hero-content,
  .about-content,
  .contact-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .about-text {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 60px 0;
  }
  
  .background-video {
    /* 在移动设备上确保视频覆盖整个区域 */
    min-width: 120%;
    min-height: 120%;
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
  }
  
  .hero-buttons {
    justify-content: center;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .store-section,
  .about-section,
  .features-section,
  .applications-section,
  .news-section,
  .contact-section {
    padding: 60px 0;
  }
  
  .product-grid,
  .news-grid {
    grid-template-columns: 1fr;
  }
  
  .language-switcher-container {
    top: 10px;
    right: 10px;
  }
  
  .contact-form {
    padding: 24px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 16px;
  }
  
  .hero-title {
    font-size: 1.8rem;
  }
  
  .btn {
    padding: 10px 20px;
    font-size: 14px;
  }
}
</style>